import React, { useEffect, useState, useCallback } from "react";
import Tabs from "../../../../../common/element/Tabs";
import WorkerName from "./WorkerName";
import Documents from "../SpecificWorkerTabs/Documents";
import Clients from "../SpecificWorkerTabs/Inductions";
import Workers from "../SpecificWorkerTabs/SiteLog";
import { GetWorkerOverviewDetailsById } from "../../../../../actions/admin-worker/GetWorkerOverviewDetailsById";
// import Providers from "../../Client/SpecificClientTabs/Providers";
import Providers from "../SpecificWorkerTabs/Contractors";
import ClientsAssigned from "../SpecificWorkerTabs/ClientsAssigned";
import Overview from "../SpecificWorkerTabs/Overview";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import { redirectSpecWorker } from "../../../../../redux/classes/admin-worker/RedirectWorkerSlice";
import { de } from "date-fns/locale";
const { TabNav, TabList, TabContent } = Tabs;
const SpecificWorker = () => {
  const dispatch = useDispatch();
  const { id, ind_Id, providerOrgId } = useParams();
  const { workerRedirectSpecificData } = useSelector((state) => state)
  const [workerSpecficData, setWorkerSpecficData] = useState(null);
  const [hasFetched, setHasFetched] = useState(false)
  useEffect(() => {
    // Set breadcrumbs when the component mounts
    dispatch(
      setBreadcrumbs([
        {
          label: "View All Worker",
          url: "/admin/worker/view-all-worker",
          home: "/admin/worker/dashboard"
        },
        {
          label: `${workerSpecficData?.first_name || ''} ${workerSpecficData?.last_name || ''}`,
          url: `/admin/worker/view-all-worker/specific-worker/${encodeURIComponent(id)}/${ind_Id}/${providerOrgId}`,
        },
      ])
    );
  }, [workerSpecficData, workerRedirectSpecificData]);

  useEffect(() => {
    if (workerSpecficData && workerRedirectSpecificData?.first_name) {
      setWorkerSpecficData(workerRedirectSpecificData)
    }
  }, [workerRedirectSpecificData])
  const GetSpecWorkerOverviewDetailsById = useCallback(() => {
    // if (workerRedirectSpecificData?.individual_id && !hasFetched) { // this is old code 
    if (ind_Id && !hasFetched) {
      dispatch(
        GetWorkerOverviewDetailsById({ individual_id: ind_Id })
      ).then((response) => {
        if (response?.success) {
          setWorkerSpecficData(response?.data);
          dispatch(redirectSpecWorker(response?.data));
          setHasFetched(true); // Set flag to true after data is fetched
        }
      });
    }
  }, [dispatch, workerRedirectSpecificData, hasFetched]);

  useEffect(() => {
    GetSpecWorkerOverviewDetailsById();
  }, []);
  return (
    <React.Fragment>
      <WorkerName />
      <Tabs defaultValue="tab1" variant="pill" className="contractorTabsList">
        <div className=" bg-blue-25 border border-gray-100 p-1 rounded-lg mb-5">
          <TabList>
            <TabNav value="tab1">Overview</TabNav>
            <TabNav value="tab2">My Documents</TabNav>
            <TabNav value="tab6">Clients Assigned</TabNav>
            <TabNav value="tab3">Inductions</TabNav>
            <TabNav value="tab4">Site Log</TabNav>
            <TabNav value="tab5">Providers</TabNav>
          </TabList>
        </div>
        <div className="">
          <TabContent value="tab1">
            <Overview />
          </TabContent>
          <TabContent value="tab2">
            <Documents />
          </TabContent>
          <TabContent value="tab3">
            <Clients />
          </TabContent>
          <TabContent value="tab4">
            <Workers />
          </TabContent>
          <TabContent value="tab5">
            <Providers />
          </TabContent>
          <TabContent value="tab6" >
            <ClientsAssigned />
          </TabContent>
        </div>
      </Tabs>
    </React.Fragment>
  );
};

export default SpecificWorker;
